// material mui
import {
    Avatar,
    Typography,
    Grid,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@mui/material';
import { GetUserType } from 'store/TextFormat';
import DEFAULT_USER_IMAGE from 'assets/images/users/default_user.png';

// third party
import moment from 'moment-timezone';

const List = ({ rows, limit, page }) => {

    const getDiff = (onDate, offDate) => {
        const startTime = moment(onDate.replace('T', ' ').replace('.000Z', ''), 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
        const endTime = moment(offDate.replace('T', ' ').replace('.000Z', ''), 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
        const duration = moment.duration(moment(endTime).diff(startTime));
        const hours = parseInt(duration.asHours());
        const minutes = parseInt(duration.asMinutes()) % 60;
        const seconds = parseInt(duration.asSeconds()) % 60;
        const hoursLabel = hours <= 1 ? 'hr' : 'hrs'
        const minutessLabel = minutes <= 1 ? 'min' : 'mins'
        const secondsLabel = seconds <= 1 ? 'sec' : 'secs'
        return `${hours} ${hoursLabel} ${minutes} ${minutessLabel} ${seconds} ${secondsLabel}`;
    };

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ pl: 3 }}>#</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }}>Scored By</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }}>Booking ID</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }}>Match ID</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }}>Team A</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }}>Team B</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>Start Time</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>End Time</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>Used Duration</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        rows.map((row, index) =>
                            <TableRow hover key={index}>
                                <TableCell sx={{ pl: 3 }}>{page * limit - limit + index + 1}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }}>
                                    <Grid container spacing={1} alignItems="center">
                                        <Grid item spacing={1}>
                                            <Avatar alt="User" src={row.uu_image ? row.uu_image : DEFAULT_USER_IMAGE} />
                                        </Grid>
                                        <Grid>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {row.uu_firstname} {row.booked_user_lastname}
                                            </Typography>
                                            <Typography align="left" variant="subtitle2">
                                                {row.uu_code} / {GetUserType(row.uu_type)}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }}>{row.code}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }}>{row.match_code}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {row.team_a_name}
                                            </Typography>
                                            <Typography align="left" variant="subtitle2" noWrap>
                                                {row.team_a_code}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {row.team_b_name}
                                            </Typography>
                                            <Typography align="left" variant="subtitle2" noWrap>
                                                {row.team_b_code}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {moment(row.start_time.replace('T', ' ').replace('.000Z', '')).format('DD-MM-YYYY')}
                                            </Typography>
                                            <Typography align="left" variant="subtitle2" noWrap>
                                                {moment(row.start_time.replace('T', ' ').replace('.000Z', '')).format('HH:mm:ss')}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    {
                                        row.end_time ? (
                                            <Grid container spacing={2} alignItems="center">
                                                <Grid item xs zeroMinWidth>
                                                    <Typography align="left" variant="subtitle1" component="div">
                                                        {moment(row.end_time.replace('T', ' ').replace('.000Z', '')).format('DD-MM-YYYY')}
                                                    </Typography>
                                                    <Typography align="left" variant="subtitle2" noWrap>
                                                        {moment(row.end_time.replace('T', ' ').replace('.000Z', '')).format('HH:mm:ss')}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        ) : ''
                                    }
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    {row.end_time ? getDiff(row.start_time, row.end_time) : ''}
                                </TableCell>
                            </TableRow>
                        )
                    }
                </TableBody>
            </Table>
        </TableContainer >
    );
}

export default List;